import { render, staticRenderFns } from "./IconScaleSolid.vue?vue&type=template&id=f0afcf3c"
import script from "./IconScaleSolid.vue?vue&type=script&lang=js"
export * from "./IconScaleSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports